import React from 'react';
import BlockChooser from '@plone/volto/components/manage/BlockChooser/BlockChooser';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import { blockHasValue } from '@plone/volto/helpers/Blocks/Blocks';
import config from '@plone/volto/registry';
import cx from 'classnames';
import includes from 'lodash/includes';
import isBoolean from 'lodash/isBoolean';
import { defineMessages, injectIntl } from 'react-intl';
import { Button } from 'semantic-ui-react';
import { doesNodeContainClick } from 'semantic-ui-react/dist/commonjs/lib';

import addSVG from '@plone/volto/icons/circle-plus.svg';
import trashSVG from '@plone/volto/icons/delete.svg';
import dragSVG from '@plone/volto/icons/drag.svg';

const messages = defineMessages({
  unknownBlock: {
    id: 'Unknown Block',
    defaultMessage: 'Unknown Block {block}',
  },
  delete: {
    id: 'delete',
    defaultMessage: 'delete',
  },
});

class EditBlockWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      addNewBlockOpened: false,
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (e) => {
    if (
      this.blockNode.current &&
      doesNodeContainClick(this.blockNode.current, e)
    )
      return;

    if (this.state.addNewBlockOpened) {
      this.setState({
        addNewBlockOpened: false,
      });
      return true;
    }
  };

  blockNode = React.createRef();

  render() {
    const { intl, blockProps, draginfo, extraControls, disabled, children } =
      this.props;

    const {
      allowedBlocks,
      block,
      data,
      onSelectBlock,
      onDeleteBlock,
      onMutateBlock,
      onInsertBlock,
      onChangeBlock,
      selected,
    } = blockProps;
    const type = data['@type'];
    const { disableNewBlocks } = data;
    const dragVisible = !data.fixed;
    const visible = selected;

    const required = isBoolean(data.required)
      ? data.required
      : includes(config.blocks.requiredBlocks, type);

    // Get editing instructions from block settings or props
    let instructions = data?.instructions?.data || data?.instructions;
    if (!instructions || instructions === '<p><br/></p>') {
      instructions = '';
    }

    return (
      <div ref={this.blockNode}>
        <div
          ref={draginfo?.innerRef}
          {...(selected ? draginfo?.draggableProps : null)}
          className={`block-editor-${data['@type']}`}
        >
          {(!selected || !visible || disabled) && (
            <div
              style={{
                display: 'none',
                // keep react-beautiful-dnd happy
              }}
              {...draginfo.dragHandleProps}
            ></div>
          )}
          {visible && (
            <div className="block-toolbar">
              {instructions ? extraControls : ''}

              {!disabled && (
                <div className="block-tools">
                  <div
                    style={{
                      display: dragVisible ? 'inline-block' : 'none',
                    }}
                    {...draginfo.dragHandleProps}
                    className="drag handle wrapper-responsive-content-block"
                  >
                    <Button icon basic title="Drag and drop">
                      <Icon name={dragSVG} size="19px" />
                    </Button>
                  </div>

                  {!disableNewBlocks && (
                    <Button
                      icon
                      basic
                      title="Add block"
                      onClick={() => {
                        this.setState({
                          addNewBlockOpened: !this.state.addNewBlockOpened,
                        });
                      }}
                      className="responsive-content-block-add-button"
                    >
                      <Icon name={addSVG} className="" size="19px" />
                    </Button>
                  )}
                  {!required && (
                    <Button
                      icon
                      basic
                      title="Remove block"
                      onClick={() => onDeleteBlock(block)}
                      className="delete-button-responsive-content-block"
                      aria-label={intl.formatMessage(messages.delete)}
                    >
                      <Icon name={trashSVG} size="19px" />
                    </Button>
                  )}
                  {this.state.addNewBlockOpened && (
                    <BlockChooser
                      onMutateBlock={(id, value) => {
                        onMutateBlock(id, value);
                        this.setState({ addNewBlockOpened: false });
                      }}
                      onInsertBlock={(id, value) => {
                        //customizado em relação ao padrão para remover bloco de texto vazio
                        if (blockHasValue(data)) {
                          onSelectBlock(onInsertBlock(id, value));
                        } else {
                          onChangeBlock(id, value);
                        }
                        //fim da customização
                        this.setState({ addNewBlockOpened: false });
                      }}
                      currentBlock={block}
                      allowedBlocks={allowedBlocks}
                    />
                  )}
                </div>
              )}
            </div>
          )}

          <div
            className={cx('ui drag block wrapper inner', type, {
              multiSelected: this.props.multiSelected,
            })}
          >
            {children}
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(EditBlockWrapper);
